import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CardResource } from 'src/app/interfaces/card-resouce';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { User } from 'src/app/interfaces/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { CardService } from 'src/app/services/card.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  /**
   * is the Page finished Loading
   */
  finishedLoading: boolean = false;
  /**
   * The Columns of the Table to be displayed
   */
  displayedColumns = ['number', 'ID', 'user', 'state', 'date', 'last_change', 'menu'];
  /**
   * The States of Cards
   */
  states = [
    { value: 'CREATED', viewValue: 'Erstellt', 'state': false },
    { value: 'AVAILABLE', viewValue: 'Verfügbar', 'state': false },
    { value: 'REQUESTED', viewValue: 'Angefordert', 'state': false },
    { value: 'ASSIGNED', viewValue: 'Zugeordnet', 'state': false },
    { value: 'ACTIVE', viewValue: 'Aktiv', 'state': false },
    { value: 'CLOSE_REQUEST', viewValue: 'Sperrung beantrag', 'state': false },
    { value: 'CLOSED', viewValue: 'Gesperrt', 'state': false },
    { value: null, viewValue: 'keiner', 'state': false }
  ]
  /**
   * The Page of cards
   * */
  page = null;
  /**
   * the Metadata of the Card
   */
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  /**
   * The data to be displayed
   */
  dataSource: MatTableDataSource<any>;
  /**
   * The Form to filter the Cards
   */
  filterForm: UntypedFormGroup;
  /**
   * constructor
   * Init the FOrm
   * @param cardService 
   * @param businessuserService 
   * @param fb 
   * @param overlayService 
   * @param auth 
   * @param router 
   * @param route 
   */
  constructor(
    private cardService: CardService,
    private businessuserService: BusinessuserService,
    private fb: UntypedFormBuilder,
    private overlayService: OverlayService,
    private auth: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute) {
    this.filterForm = this.fb.group({
      searchTerm: [''],
      filterByState: null
    })
  }
/**
 * ngOnInit
 * Get the First cards
 */
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        searchTerm: params?.searchTerm,
        filterByState: params?.filterByState,
      })
      if (params?.page) {
        this.pageData.pageIndex = params?.page;
      }
      if (params?.size) {
        this.pageData.pageSize = params?.size;
      }
      this.search(this.pageData.pageIndex, this.pageData.pageSize);
    })
  }
  /**
   * Get the page of filtered cards
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }
  /**
   * Get the page of filtered cards
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.cardService.seachCards(pageIndex, pageSize, this.filterForm.value.filterByState, this.filterForm.value.searchTerm).subscribe((cards: PagedResources<CardResource>) => {
      cards.content.forEach(card => {
        this.businessuserService.getBusinessUser(card.ownerPublicId).subscribe(val => {
          card['userModel'] = val;
        })
      })
      this.dataSource = new MatTableDataSource(cards.content);
      this.page = cards.page;
      this.finishedLoading = true;
    })
  }

/**
 * Fitler the Cards
 */
  filterCards() {
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterByState: this.filterForm.value?.filterByState,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.cardService.seachCards(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterByState, this.filterForm.value.searchTerm).subscribe((cards: PagedResources<CardResource>) => {
          cards.content.forEach(card => {
            this.businessuserService.getBusinessUser(card.ownerPublicId).subscribe(val => {
              card['userModel'] = val;
            })
          })
          this.dataSource = new MatTableDataSource(cards.content);
          this.page = cards.page
        })
      })
  }
  /**
   * Reset the Filter and search for the unfilted Cards
   */
  resetFitler() {
    this.filterForm.reset()
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: "",
          filterByState: "ACTIVE",
        },
        queryParamsHandling: ''
      }).then(() => {
        this.search(this.pageData.pageIndex, this.pageData.pageSize);
      })
  }
  /**
   * Open the Dialog to show the QR Code of the Card
   * @param card 
   */
  openQRCodeDialog(card: CardResource) {
    this.overlayService.openCardQrCodeDialog("QR-Code", "Ok", card).subscribe(val => {
      console.log(val)
    })
  }
  /**
   * get the Card PDF
   * @param card 
   */
  getCardPDF(card: CardResource) {
    if(card?.userModel?.person?.displayName != null && card?.userModel?.person?.displayName != ''){
      this.cardService.getPDF(card.cardId).subscribe({
        next: blob => {
          var file = new Blob([blob], { type: 'application/pdf' });
          let pdf = URL.createObjectURL(file);
          window.open(pdf)
        },
        error: err => {
          console.log(err)
        }
      })
    }else{
      this.overlayService.openDialog("Info", "Eine Kundenkarte muss zunächst von einem Kunden angefordert sein, um Aktionen auszuführen.", "Ok")
    }
  }
  /**
   * get the CardNotification as a PDF
   */
  getCardNotificationPDF(card: CardResource) {
    this.cardService.getNotiPDF(card.cardId).subscribe({
      next: blob => {
        var file = new Blob([blob], { type: 'application/pdf' });
        let pdf = URL.createObjectURL(file);
        window.open(pdf)
      },
      error: err => {
        console.log(err)
      }
    })
  }
  /**
   * Search for the Cards if Enter is pressed
   * @param event 
   */
  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterCards()
    }
  }

  closeCard(card:CardResource){
    card.state = "CLOSE_REQUEST";
    this.cardService.editCard(card).subscribe({
      next: res =>{
        this.overlayService.openSnackBar("Karte erfolgreich bearbeitet!")
      },
      error: err =>{
        this.overlayService.openSnackBar("Fehler beim Bearbeiten, versuchen Sie es bitte später noch einmal.");
      }
    })
  }


  reopenCard(card:CardResource){
    card.state = "ACTIVE";
    this.cardService.editCard(card).subscribe({
      next: res =>{
        this.overlayService.openSnackBar("Karte erfolgreich bearbeitet!");
      },
      error: err =>{
        this.overlayService.openSnackBar("Fehler beim Bearbeiten, versuchen Sie es bitte später noch einmal.");
      }
    })
  }


}
